



























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator";
import {ChallengesApi} from "@/api/challenges.api";
import {take} from "rxjs/operators";
import {ChallengePrizes} from "@/models/challenge.model";

@Component({})
export default class ChallengerDetailDescriptionTrophy extends Vue {
  @Prop({required: true}) challengeId!: number;
  prizes: ChallengePrizes[] = []

  mounted() {
    if (this.challengeId) {
      new ChallengesApi()
              .fetchPrizes(this.challengeId)
              .pipe(take(1))
              .subscribe((prizes) => {
                this.prizes = prizes
              })
    }

  }
}
